import { Button } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useTimeoutEffect } from "@/hooks/useTimeoutEffect";

import { FilterDropdownShape } from "./Filters.type";

import "./FilterDropdownWrapper.style.less";

const FilterDropdownWrapper = ({
  className,
  filterProps,
  okButtonProps,
  resetButtonProps,
  onDropdownClose,
  children,
}) => {
  const { visible, selectedKeys } = filterProps;
  const { t } = useTranslation();

  useTimeoutEffect(
    () => {
      // Callback is run with delay to make sure it is run after the dropdown
      // is completely hidden (aka after the css animation).
      if (!visible) onDropdownClose?.();
    },
    250,
    [visible, selectedKeys]
  );

  return (
    <div className={classNames("filter-dropdown", className)}>
      <div className="filter-dropdown-content">{children}</div>
      <div className="filter-dropdown-actions">
        <Button size="small" type="link" {...resetButtonProps}>
          {t("global:table:reset")}
        </Button>
        <Button size="small" type="primary" {...okButtonProps}>
          {t("global:table:ok")}
        </Button>
      </div>
    </div>
  );
};

FilterDropdownWrapper.propTypes = {
  className: PropTypes.string,
  filterProps: FilterDropdownShape,
  okButtonProps: PropTypes.object,
  resetButtonProps: PropTypes.object,
  onDropdownClose: PropTypes.func,
  children: PropTypes.node,
};

export default FilterDropdownWrapper;
